import { setupWorker } from "msw/browser";

// Set up MSW worker with all mock handlers
export const worker = setupWorker();

const mockHandlers: any[] = [
  // ...getATLServiceAPIMock(),
];

// Initialize MSW with handlers
export async function initMocks() {
  if (typeof window === "undefined" || !mockHandlers.length) {
    return;
  }

  try {
    // Register all mock handlers
    worker.use(...mockHandlers);

    // Start the worker
    await worker.start({
      onUnhandledRequest: "bypass", // Allow unhandled requests to pass through
      serviceWorker: {
        url: "/mockServiceWorker.js",
      },
    });

    console.log("✅ MSW initialized with mock handlers");
  } catch (error) {
    console.warn("⚠️ Failed to initialize MSW:", error);
    console.warn("Make sure to run: npx msw init public/ --save");
  }
}
